/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    departmentIdSelected:0,
    defaultDataDepartment:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_DEPARTMENT_ID = 'SET_DEPARTMENT_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setDepartmentId = (payload) => ({
  type: SET_DEPARTMENT_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_DEPARTMENT_ID:
        return {
          ...state,
        departmentIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataDepartment: payload,
          }
     default:
       return state
   }
 }
 